export function checkIfStringIsValid(string) {
    return string !== null && string !== undefined && string.trim() !== "";
  }
  